import moment from 'moment'

export const getOffset : any = () => {
    return (moment().utcOffset() / 60) * 3600000
}

